package uz.ferro.shop.pages.admin.debt.model

import kotlinx.serialization.Serializable

@Serializable
data class DebtItem(
    val type: String,
    val date: String,
    val dueDate: String,
    val taxDate: String,
    val documentId: Long?,
    val salesPointId: String?,
    val salesPersonId: Long?,
    val salesPersonName: String?,
    val debit: Double?,
    val credit: Double?
)